module.exports = __webpack_public_path__ + "img/icon-error.6dfcfa4e.png";